// v16.60.19 — Modal xem tài liệu pháp lý ngay trên trang Đăng ký (không rời
// trang → không mất dữ liệu form đã điền). Nhúng trang qua iframe ?embed=1
// để ẩn nút "Quay lại" của trang gốc.
import { X } from "@phosphor-icons/react";

const DOCS = {
  terms: { title: "Điều khoản Sử dụng", src: "/terms?embed=1" },
  guidelines: { title: "Cam kết Cộng đồng", src: "/community-guidelines?embed=1" },
};

export default function LegalDocModal({ doc, onClose }) {
  const info = DOCS[doc];
  if (!info) return null;
  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center p-3 sm:p-6"
      data-testid="legal-doc-modal"
    >
      <div
        className="absolute inset-0 bg-black/75 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden
      />
      <div className="relative z-10 w-full max-w-2xl h-[85vh] rounded-2xl overflow-hidden bg-[#0B1220] border border-white/12 shadow-2xl flex flex-col">
        <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-white/10 bg-[#070C15]">
          <div className="text-[14px] font-black text-white truncate">{info.title}</div>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white/8 hover:bg-white/15 border border-white/15 text-white text-[13px] font-bold transition"
            data-testid="legal-doc-modal-close"
          >
            <X size={15} weight="bold" /> Đóng
          </button>
        </div>
        <iframe
          src={info.src}
          title={info.title}
          className="flex-1 w-full border-0 bg-[#0B1220]"
          data-testid="legal-doc-modal-iframe"
        />
      </div>
    </div>
  );
}
